// frontend/src/pages/board/components/details/showDetailAttachment/AttachmentList.js
import React from "react";
import Box from "@mui/material/Box";
import { Stack } from "@mui/material";
import AttachFile from "../components/changeBoard/attachFile/AttachFile";
import AttachmentItem from "./AttchementItem";

function AttachmentList({
  attachments,
  isMobile,
  cardAttachment,
  cardId,
  handleSlideShowAttachment,
  handleView,
  handleDownload,
  handleDelete,
  setDeleteAttachmentId,
}) {

  return (
    <>
      {cardAttachment?.data?.data?.totalRecord !== 0 &&
        (isMobile ? (
          <Stack direction="row" justifyContent="space-between" alignItems="center" my={1} marginTop={2.5} className="mobile-attachment-list-container">
            <p className="attachment-para mobile-attachment-para" style={{marginTop: 0}}>
              Attachments ({cardAttachment?.data?.data?.totalRecord}){" "}
            </p>
            {cardAttachment?.data?.data?.totalRecord !== 0 && (
              <AttachFile cardId={cardId} isIconBtn={true} />
            )}
          </Stack>
        ) : (
          <p className="attachment-para">
            Attachments ({cardAttachment?.data?.data?.totalRecord})
          </p>
        ))}
      {cardAttachment?.data?.data?.totalRecord !== 0 && (
        <div className={isMobile ? "mobile-attachment-box" : "attachment-box"}>
          {cardAttachment?.data?.data?.responseData
            ?.sort((a, b) => a.card_attachment_id - b.card_attachment_id)
            .map((item) => {
              attachments.push(item);
              return (
                <AttachmentItem
                  key={item.card_attachment_id}
                  item={item}
                  isMobile={isMobile}
                  handleSlideShowAttachment={handleSlideShowAttachment}
                  handleView={handleView}
                  handleDownload={handleDownload}
                  handleDelete={handleDelete}
                  setDeleteAttachmentId={setDeleteAttachmentId}
                />
              );
            })}
          {!isMobile && cardAttachment?.data?.data?.totalRecord !== 0 && (
            <AttachFile cardId={cardId} isIconBtn={true} />
          )}
        </div>
      )}
    </>
  );
}

export default React.memo(AttachmentList);
